var map = {
	"./logo-1-dark.png": "5599",
	"./logo-1-light.png": "d29c",
	"./logo-2-dark.png": "b228",
	"./logo-2-light.png": "68e2",
	"./logo-3-dark.png": "fe98",
	"./logo-3-light.png": "5b8f",
	"./logo-4-dark.png": "512b",
	"./logo-4-light.png": "ee5e",
	"./logo-5-dark.png": "ec02",
	"./logo-5-light.png": "961b",
	"./logo-6-dark.png": "e787",
	"./logo-6-light.png": "4615"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e7dd";